import 'moment/locale/ar';
import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';

interface GenericCardProps {
    styles?: React.CSSProperties
    children: any
}
const GenericCard: React.FC<GenericCardProps> = ({ styles, children }) => {
    const defaultStyles: React.CSSProperties = {
        marginTop: 0,
        textAlign: "center",
        color: "white",
        backgroundColor: "#444444",
    };
    return (
        <Col>
            <Card style={styles ? styles : defaultStyles}>
                <CardBody>{children}</CardBody>
            </Card>
        </Col>
    );
};

export default GenericCard;